import { Route } from 'react-router-dom';
import React from 'react';

export const renderAutoForm = (path, state, variant, updateAppState, Component, setAlternativeVariantObject, switchToEnglishVariant, switchToOriginalVariant, index) => (
  <Route exact key={`${index}_route`} path={`/${path}`} element={<Component {...state} variant={variant} updateAppState={updateAppState} setAlternativeVariantObject={setAlternativeVariantObject} switchToEnglishVariant={switchToEnglishVariant} switchToOriginalVariant={switchToOriginalVariant} />} />
);

export const renderReduxAutoForm = (path, state, variant, updateAppState, Component, setAlternativeVariantObject, switchToEnglishVariant, switchToOriginalVariant, index) => (
  <Route exact key={`${index}_route`} path={`/${path}`} element={<Component {...state} variant={variant} updateAppState={updateAppState} setAlternativeVariantObject={setAlternativeVariantObject} switchToEnglishVariant={switchToEnglishVariant} switchToOriginalVariant={switchToOriginalVariant} />} />
);

export const renderLifeForm = (path, state, variant, updateAppState, Component, index) => (
  <Route exact key={`${index}_route`} path={`/${path}`} element={<Component {...state} variant={variant} updateAppState={updateAppState} />} />
);

export const renderLifeStatic = (path, state, Component) => (
  <Route exact path={`/${path}`} element={<Component {...state} />} />
);

export const renderLifeFullPath = (path, state, Component) => (
  <Route exact path={`/${path}`} element={<Component {...state} />} />
);
